module.exports = __webpack_public_path__ + "static/media/adpathy.d6918e5a.png";